import React from "react";
import { APICall } from "../../../api_helper";
import { DropdownFillers } from "../../../types";
import { useQueryWrapper } from "../../../helper";
import { FormDropdown } from "semantic-ui-react";

export const NewQueryDropdownFieldComponent = (props: {
  props: NewQueryDropdownFieldComponentProps;
  data: any;
  setData: any;
}) => {
  const [options, setOptions] = React.useState<DropdownFillers[]>([]);

  useQueryWrapper(
    props.props.apiCall.documentNode,
    props.props.apiVariables,
    (data) => {
      const newOptions: DropdownFillers[] = [];
      newOptions.push({ text: props.props.noSelectionLabel, value: 0, key: 0 });
      for (const response of data[props.props.apiCall.key]) {
        newOptions.push({
          text: response.name,
          value: response.id,
          key: response.id,
        });
      }
      setOptions(newOptions);
    },
  );

  return (
    <FormDropdown
      fluid
      selection
      search
      label={props.props.label}
      required={props.props.required}
      options={options}
      value={props.data[props.props.key]}
      placeholder={props.props.noSelectionLabel}
      onChange={(event, data) => {
        const newValues = { ...props.data };
        newValues[props.props.key] = data.value;
        props.setData(newValues);
      }}
    />
  );
};

export type NewQueryDropdownFieldComponentProps = {
  type: "query_dropdown";
  key: string;
  label: string;
  required: boolean;
  noSelectionLabel: string;
  apiCall: APICall;
  apiVariables: any;
};
